import { getBaseAutomationUrl } from '@atlassian/jira-automation-menu/src/common/utils.tsx';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import type { MatcherLocation } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/types.tsx';
import { getNextgenSettingsUrl } from '@atlassian/jira-project-settings-apps-common/src/urls.tsx';
import { toProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';

export type AutomationPaths = {
	jira: string;
	serviceDesk: string;
};

export const JIRA_AUTOMATION_ADDON_KEY = 'com.codebarrel.addons.automation';

export const getAutomationPaths = ({
	projectKey,
	isSimplified,
}: {
	projectKey: string;
	isSimplified: boolean;
}): AutomationPaths => {
	const nextGenSettingsBaseUrl = getNextgenSettingsUrl(SERVICE_DESK_PROJECT, projectKey);
	return {
		serviceDesk: `${nextGenSettingsBaseUrl}/automation`,
		jira: getBaseAutomationUrl({
			projectType: SERVICE_DESK_PROJECT,
			projectKey: toProjectKey(projectKey),
			isSimplified,
		}),
	};
};

export const isJiraAutomationSelected =
	(automationPaths: AutomationPaths) =>
	({ pathname }: MatcherLocation) =>
		automationPaths.jira.includes(pathname);

export const isServiceDeskAutomationSelected =
	(automationPaths: AutomationPaths) =>
	({ pathname }: MatcherLocation) =>
		pathname.includes(automationPaths.serviceDesk);

export const isAutomationSubNavSelected =
	(automationPaths: AutomationPaths) => (currentLocation: MatcherLocation) =>
		isJiraAutomationSelected(automationPaths)(currentLocation) ||
		isServiceDeskAutomationSelected(automationPaths)(currentLocation);
